import * as THREE from 'three';

const line = [
	{ x: 3.68247, y: 359.792999, z: 57.501801 },
	{ x: -0.627902, y: 363.987, z: 54.568699 },
	{ x: -5.03072, y: 368.14801, z: 51.563801 },
	{ x: -9.52597, y: 372.276001, z: 48.487301 },
	{ x: -14.1137, y: 376.372009, z: 45.3391 },
	{ x: -18.7938, y: 380.434998, z: 42.119099 },
	{ x: -23.566401, y: 384.464996, z: 38.827499 },
	{ x: -28.4314, y: 388.463013, z: 35.464298 },
	{ x: -33.388901, y: 392.428009, z: 32.029301 },
	{ x: -38.4389, y: 396.359985, z: 28.5226 },
	{ x: -43.5812, y: 400.26001, z: 24.9443 },
	{ x: -48.816002, y: 404.127014, z: 21.294201 },
	{ x: -54.143299, y: 407.962006, z: 17.5725 },
	{ x: -59.563, y: 411.764008, z: 13.7791 },
	{ x: -65.075104, y: 415.53299, z: 9.91401 },
	{ x: -70.679703, y: 419.269012, z: 5.97723 },
	{ x: -76.376801, y: 422.972992, z: 1.96876 },
	{ x: -82.166199, y: 426.644012, z: -2.1114 },
	{ x: -88.048203, y: 430.28299, z: -6.26325 },
	{ x: -93.931198, y: 433.902008, z: -10.4146 },
	{ x: -99.7239, y: 437.516998, z: -14.4931 },
	{ x: -105.426003, y: 441.125, z: -18.498899 },
	{ x: -111.038002, y: 444.729004, z: -22.431999 },
	{ x: -116.559998, y: 448.328003, z: -26.292299 },
	{ x: -121.991997, y: 451.92099, z: -30.079901 },
	{ x: -127.333, y: 455.507996, z: -33.794701 },
	{ x: -132.584, y: 459.091003, z: -37.436798 },
	{ x: -137.744003, y: 462.667999, z: -41.0061 },
	{ x: -142.813995, y: 466.23999, z: -44.502701 },
	{ x: -147.794006, y: 469.806, z: -47.926498 },
	{ x: -152.684006, y: 473.368011, z: -51.277599 },
	{ x: -157.483002, y: 476.924011, z: -54.556 },
	{ x: -162.192001, y: 480.473999, z: -57.761501 },
	{ x: -166.811005, y: 484.019989, z: -60.894402 },
	{ x: -171.339996, y: 487.559998, z: -63.954498 },
	{ x: -175.778, y: 491.093994, z: -66.941803 },
	{ x: -180.126007, y: 494.623993, z: -69.8564 },
	{ x: -184.382996, y: 498.14801, z: -72.698196 },
	{ x: -188.550003, y: 501.666992, z: -75.4673 },
	{ x: -192.626999, y: 505.179993, z: -78.163696 },
	{ x: -196.613998, y: 508.688995, z: -80.7873 },
	{ x: -200.509995, y: 512.192017, z: -83.338097 },
	{ x: -204.315994, y: 515.689026, z: -85.8162 },
	{ x: -208.031998, y: 519.182007, z: -88.221603 },
	{ x: -211.656998, y: 522.669006, z: -90.554199 },
	{ x: -215.192993, y: 526.150024, z: -92.814003 },
	{ x: -218.636993, y: 529.627014, z: -95.001099 },
	{ x: -221.992004, y: 533.098022, z: -97.115501 },
	{ x: -225.255997, y: 536.564026, z: -99.157097 },
	{ x: -228.429993, y: 540.023987, z: -101.125999 },
	{ x: -231.514008, y: 543.47998, z: -103.022003 },
	{ x: -234.507004, y: 546.929016, z: -104.845001 },
	{ x: -237.410004, y: 550.374023, z: -106.596001 },
	{ x: -240.222, y: 553.812988, z: -108.274002 },
	{ x: -242.945007, y: 557.247009, z: -109.878998 },
	{ x: -245.574005, y: 560.69397, z: -111.408997 },
	{ x: -248.106995, y: 564.169006, z: -112.860001 },
	{ x: -250.542999, y: 567.674011, z: -114.234001 },
	{ x: -252.882996, y: 571.208008, z: -115.528999 },
	{ x: -255.126999, y: 574.771973, z: -116.746002 },
	{ x: -257.273987, y: 578.36499, z: -117.885002 },
	{ x: -259.325012, y: 581.987976, z: -118.945999 },
	{ x: -261.279999, y: 585.640015, z: -119.928001 },
	{ x: -263.138, y: 589.320984, z: -120.833 },
	{ x: -264.899994, y: 593.031982, z: -121.658997 },
	{ x: -266.56601, y: 596.771973, z: -122.407997 },
	{ x: -268.13501, y: 600.541992, z: -123.078003 },
	{ x: -269.608002, y: 604.341003, z: -123.669998 },
	{ x: -270.984985, y: 608.169006, z: -124.183998 },
	{ x: -272.265015, y: 612.026978, z: -124.619003 },
	{ x: -273.449005, y: 615.914001, z: -124.976997 },
	{ x: -274.536987, y: 619.830994, z: -125.255997 },
	{ x: -275.528015, y: 623.776978, z: -125.458 },
	{ x: -276.423004, y: 627.752014, z: -125.581001 },
	{ x: -277.221985, y: 631.757019, z: -125.625999 },
	{ x: -277.924011, y: 635.791992, z: -125.593002 },
	{ x: -278.529999, y: 639.85498, z: -125.481003 },
	{ x: -279.040009, y: 643.947998, z: -125.292 },
	{ x: -279.453003, y: 648.070984, z: -125.024002 },
	{ x: -279.769989, y: 652.223022, z: -124.679001 },
	{ x: -279.990997, y: 656.403992, z: -124.254997 },
	{ x: -280.11499, y: 660.61499, z: -123.752998 },
	{ x: -280.143005, y: 664.85498, z: -123.172997 },
	{ x: -280.075012, y: 669.125, z: -122.514 },
	{ x: -279.910004, y: 673.424011, z: -121.778 },
	{ x: -279.648987, y: 677.752014, z: -120.962997 },
	{ x: -279.291992, y: 682.109985, z: -120.070999 },
	{ x: -278.838013, y: 686.497009, z: -119.099998 },
	{ x: -278.287994, y: 690.914001, z: -118.051003 },
	{ x: -277.641998, y: 695.359985, z: -116.924004 },
	{ x: -276.898987, y: 699.835022, z: -115.719002 },
	{ x: -276.066986, y: 704.284973, z: -114.456001 },
	{ x: -275.153015, y: 708.653015, z: -113.156998 },
	{ x: -274.156006, y: 712.940002, z: -111.821999 },
	{ x: -273.076996, y: 717.14502, z: -110.449997 },
	{ x: -271.915985, y: 721.268982, z: -109.042 },
	{ x: -270.671997, y: 725.310974, z: -107.597 },
	{ x: -269.346008, y: 729.27301, z: -106.115997 },
	{ x: -267.937988, y: 733.151978, z: -104.598 },
	{ x: -266.446991, y: 736.950989, z: -103.043999 },
	{ x: -264.873993, y: 740.66803, z: -101.454002 },
	{ x: -263.218994, y: 744.302979, z: -99.826797 },
	{ x: -261.481995, y: 747.857971, z: -98.163498 },
	{ x: -259.661987, y: 751.330017, z: -96.463799 },
	{ x: -257.76001, y: 754.721985, z: -94.7276 },
	{ x: -255.774994, y: 758.031982, z: -92.955002 },
	{ x: -253.707993, y: 761.260986, z: -91.145897 },
	{ x: -251.559006, y: 764.40802, z: -89.300499 },
	{ x: -249.328003, y: 767.473999, z: -87.418602 },
	{ x: -247.014008, y: 770.458984, z: -85.500198 },
	{ x: -244.617996, y: 773.362, z: -83.545403 },
	{ x: -242.139999, y: 776.184021, z: -81.554199 },
	{ x: -239.578995, y: 778.924011, z: -79.526604 },
	{ x: -236.936005, y: 781.583008, z: -77.462502 },
	{ x: -234.210999, y: 784.161011, z: -75.362 },
	{ x: -231.403, y: 786.656982, z: -73.225098 },
	{ x: -228.513, y: 789.072021, z: -71.051697 },
	{ x: -225.541, y: 791.405029, z: -68.841904 },
	{ x: -222.485992, y: 793.656982, z: -66.595596 },
	{ x: -219.348999, y: 795.828003, z: -64.312897 },
	{ x: -216.130005, y: 797.916992, z: -61.993801 },
	{ x: -212.828003, y: 799.924988, z: -59.638302 },
	{ x: -209.444, y: 801.85199, z: -57.2463 },
	{ x: -205.977997, y: 803.697021, z: -54.817902 },
	{ x: -202.429993, y: 805.460999, z: -52.353001 },
	{ x: -198.798996, y: 807.143005, z: -49.851799 },
	{ x: -195.085999, y: 808.744019, z: -47.314098 },
	{ x: -191.343994, y: 810.265015, z: -44.7556 },
	{ x: -187.626999, y: 811.705017, z: -42.192101 },
	{ x: -183.936005, y: 813.065002, z: -39.623699 },
	{ x: -180.270004, y: 814.344971, z: -37.050098 },
	{ x: -176.628006, y: 815.544006, z: -34.4716 },
	{ x: -173.011993, y: 816.664001, z: -31.888 },
	{ x: -169.421005, y: 817.703003, z: -29.2994 },
	{ x: -165.854996, y: 818.663025, z: -26.705799 },
	{ x: -162.315002, y: 819.541992, z: -24.107201 },
	{ x: -158.798996, y: 820.341003, z: -21.5035 },
	{ x: -155.309006, y: 821.059021, z: -18.8948 },
	{ x: -151.843002, y: 821.697998, z: -16.281099 },
	{ x: -148.403, y: 822.257019, z: -13.6623 },
	{ x: -144.988007, y: 822.734985, z: -11.0386 },
	{ x: -141.598007, y: 823.132996, z: -8.40976 },
	{ x: -138.233002, y: 823.450989, z: -5.77593 },
	{ x: -134.893005, y: 823.689026, z: -3.13708 },
	{ x: -131.578995, y: 823.846985, z: -0.493209 },
	{ x: -128.289001, y: 823.924988, z: 2.15569 },
	{ x: -125.025002, y: 823.921997, z: 4.80962 },
	{ x: -121.785004, y: 823.840027, z: 7.46857 },
	{ x: -118.570999, y: 823.677002, z: 10.1325 },
	{ x: -115.382004, y: 823.434021, z: 12.8015 },
	{ x: -112.218002, y: 823.111023, z: 15.4756 },
	{ x: -109.080002, y: 822.70697, z: 18.1546 },
	{ x: -105.966003, y: 822.223999, z: 20.838699 },
	{ x: -102.876999, y: 821.661011, z: 23.5278 },
	{ x: -99.814003, y: 821.017029, z: 26.221901 },
	{ x: -96.775703, y: 820.29303, z: 28.921101 },
	{ x: -93.762497, y: 819.489014, z: 31.625299 },
	{ x: -90.774498, y: 818.60498, z: 34.334499 },
	{ x: -87.8116, y: 817.640991, z: 37.048698 },
	{ x: -84.873802, y: 816.596008, z: 39.768002 },
	{ x: -81.961197, y: 815.471985, z: 42.492199 },
	{ x: -79.073601, y: 814.267029, z: 45.2216 },
	{ x: -76.211197, y: 812.981995, z: 47.955898 },
	{ x: -73.422997, y: 811.609009, z: 50.690498 },
	{ x: -70.758202, y: 810.140015, z: 53.420799 },
	{ x: -68.216599, y: 808.575012, z: 56.146599 },
	{ x: -65.798401, y: 806.913025, z: 58.868099 },
	{ x: -63.503502, y: 805.155029, z: 61.585098 },
	{ x: -61.332001, y: 803.302002, z: 64.297699 },
	{ x: -59.283699, y: 801.35199, z: 67.005997 },
	{ x: -57.358799, y: 799.30603, z: 69.709801 },
	{ x: -55.557201, y: 797.163025, z: 72.409203 },
	{ x: -53.879002, y: 794.924988, z: 75.104202 },
	{ x: -52.324001, y: 792.590027, z: 77.794899 },
	{ x: -50.892399, y: 790.159973, z: 80.481102 },
	{ x: -49.584099, y: 787.632996, z: 83.162903 },
	{ x: -48.399101, y: 785.01001, z: 85.840302 },
	{ x: -47.337502, y: 782.291016, z: 88.513298 },
	{ x: -46.3992, y: 779.474976, z: 91.181999 },
	{ x: -45.584202, y: 776.564026, z: 93.846199 },
	{ x: -44.892502, y: 773.55603, z: 96.505997 },
	{ x: -44.3242, y: 770.452026, z: 99.1614 },
	{ x: -43.879101, y: 767.252014, z: 101.811996 },
	{ x: -43.5574, y: 763.955994, z: 104.459 },
	{ x: -43.3591, y: 760.564026, z: 107.100998 },
	{ x: -43.284, y: 757.075989, z: 109.738998 },
	{ x: -43.332298, y: 753.491028, z: 112.372002 },
	{ x: -43.503899, y: 749.809998, z: 115.000999 },
	{ x: -43.798801, y: 746.03302, z: 117.625999 },
	{ x: -44.217098, y: 742.159973, z: 120.246002 },
	{ x: -44.758701, y: 738.190979, z: 122.862 },
	{ x: -45.4235, y: 734.125977, z: 125.473 },
	{ x: -46.2118, y: 729.963989, z: 128.080002 },
	{ x: -47.123299, y: 725.70697, z: 130.682999 },
	{ x: -48.158199, y: 721.353027, z: 133.281006 },
	{ x: -49.316399, y: 716.903015, z: 135.875 },
	{ x: -50.5979, y: 712.356995, z: 138.464005 },
	{ x: -52.0028, y: 707.713989, z: 141.048996 },
	{ x: -53.530899, y: 702.976013, z: 143.630005 },
	{ x: -55.144402, y: 698.187012, z: 146.162994 },
	{ x: -56.805, y: 693.393982, z: 148.606003 },
	{ x: -58.512798, y: 688.596008, z: 150.959 },
	{ x: -60.267899, y: 683.79303, z: 153.220993 },
	{ x: -62.070202, y: 678.986023, z: 155.393997 },
	{ x: -63.919601, y: 674.174011, z: 157.475998 },
	{ x: -65.816299, y: 669.357971, z: 159.468002 },
	{ x: -67.760201, y: 664.536987, z: 161.369003 },
	{ x: -69.751297, y: 659.711975, z: 163.181 },
	{ x: -71.789597, y: 654.882019, z: 164.901993 },
	{ x: -73.875099, y: 650.046997, z: 166.533005 },
	{ x: -76.007797, y: 645.208008, z: 168.072998 },
	{ x: -78.187698, y: 640.364014, z: 169.524002 },
	{ x: -80.414902, y: 635.515991, z: 170.884003 },
	{ x: -82.689201, y: 630.663025, z: 172.154007 },
	{ x: -85.010696, y: 625.80603, z: 173.334 },
	{ x: -87.379501, y: 620.94397, z: 174.423004 },
	{ x: -89.795502, y: 616.077026, z: 175.421997 },
	{ x: -92.258598, y: 611.205994, z: 176.330994 },
	{ x: -94.768997, y: 606.330017, z: 177.149994 },
	{ x: -97.326599, y: 601.448975, z: 177.878006 },
	{ x: -99.931396, y: 596.565002, z: 178.516998 },
	{ x: -102.583, y: 591.674988, z: 179.065002 },
	{ x: -105.282997, y: 586.781006, z: 179.522995 },
	{ x: -108.028999, y: 581.882019, z: 179.889999 },
	{ x: -110.822998, y: 576.979004, z: 180.167007 },
	{ x: -113.663002, y: 572.070984, z: 180.354996 },
	{ x: -116.551003, y: 567.158997, z: 180.451004 },
	{ x: -119.487, y: 562.242004, z: 180.457993 },
	{ x: -122.469002, y: 557.320007, z: 180.373993 },
	{ x: -125.499001, y: 552.393982, z: 180.199997 },
	{ x: -128.576004, y: 547.463013, z: 179.936005 },
	{ x: -131.699997, y: 542.528015, z: 179.582001 },
	{ x: -134.871002, y: 537.588013, z: 179.136993 },
	{ x: -138.089005, y: 532.643005, z: 178.602997 },
	{ x: -141.354996, y: 527.69397, z: 177.977997 },
	{ x: -144.591003, y: 522.76001, z: 177.264999 },
	{ x: -147.720993, y: 517.859985, z: 176.466003 },
	{ x: -150.744003, y: 512.994995, z: 175.582001 },
	{ x: -153.660995, y: 508.164001, z: 174.613007 },
	{ x: -156.472, y: 503.367004, z: 173.557999 },
	{ x: -159.175995, y: 498.605011, z: 172.417999 },
	{ x: -161.774002, y: 493.877014, z: 171.192001 },
	{ x: -164.266006, y: 489.18399, z: 169.880005 },
	{ x: -166.651001, y: 484.524994, z: 168.483994 },
	{ x: -168.929993, y: 479.899994, z: 167.001007 },
	{ x: -171.102997, y: 475.309998, z: 165.432999 },
	{ x: -173.169006, y: 470.753998, z: 163.779999 },
	{ x: -175.128998, y: 466.231995, z: 162.041 },
	{ x: -176.981995, y: 461.744995, z: 160.216995 },
	{ x: -178.729004, y: 457.291992, z: 158.307007 },
	{ x: -180.369995, y: 452.873993, z: 156.311996 },
	{ x: -181.904007, y: 448.48999, z: 154.231003 },
	{ x: -183.332001, y: 444.140015, z: 152.065002 },
	{ x: -184.654007, y: 439.825012, z: 149.813004 },
	{ x: -185.869003, y: 435.544006, z: 147.475998 },
	{ x: -186.977997, y: 431.298004, z: 145.052994 },
	{ x: -187.981003, y: 427.085999, z: 142.544998 },
	{ x: -188.876999, y: 422.90799, z: 139.951004 },
	{ x: -189.667007, y: 418.765015, z: 137.272003 },
	{ x: -190.350006, y: 414.656006, z: 134.507004 },
	{ x: -190.927002, y: 410.580994, z: 131.656998 },
	{ x: -191.397995, y: 406.540985, z: 128.720993 },
	{ x: -191.761993, y: 402.535004, z: 125.699997 },
	{ x: -192.020996, y: 398.563995, z: 122.593002 },
	{ x: -192.171997, y: 394.627014, z: 119.401001 },
	{ x: -192.218002, y: 390.725006, z: 116.123001 },
	{ x: -192.156998, y: 386.855988, z: 112.760002 },
	{ x: -191.988998, y: 383.022003, z: 109.311996 },
	{ x: -191.714996, y: 379.222992, z: 105.778 },
	{ x: -191.335007, y: 375.458008, z: 102.157997 },
	{ x: -190.848999, y: 371.72699, z: 98.452698 },
	{ x: -190.272995, y: 368.071991, z: 94.707298 },
	{ x: -189.623993, y: 364.53299, z: 90.966904 },
	{ x: -188.903, y: 361.110992, z: 87.2313 },
	{ x: -188.108994, y: 357.806, z: 83.500702 },
	{ x: -187.242996, y: 354.615997, z: 79.775002 },
	{ x: -186.304001, y: 351.544006, z: 76.054199 },
	{ x: -185.292007, y: 348.588013, z: 72.338303 },
	{ x: -184.207993, y: 345.747986, z: 68.627403 },
	{ x: -183.050995, y: 343.024994, z: 64.921402 },
	{ x: -181.820999, y: 340.419006, z: 61.220299 },
	{ x: -180.518997, y: 337.928009, z: 57.5242 },
	{ x: -179.143997, y: 335.554993, z: 53.833 },
	{ x: -177.695999, y: 333.298004, z: 50.146702 },
	{ x: -176.175995, y: 331.157013, z: 46.465302 },
	{ x: -174.582993, y: 329.132996, z: 42.788898 },
	{ x: -172.917999, y: 327.226013, z: 39.117298 },
	{ x: -171.179993, y: 325.434998, z: 35.450802 },
	{ x: -169.369003, y: 323.760986, z: 31.789101 },
	{ x: -167.485992, y: 322.203003, z: 28.132401 },
	{ x: -165.529999, y: 320.760986, z: 24.480499 },
	{ x: -163.501007, y: 319.436005, z: 20.8337 },
	{ x: -161.399994, y: 318.227997, z: 17.1917 },
	{ x: -159.225998, y: 317.135986, z: 13.5547 },
	{ x: -156.979004, y: 316.161011, z: 9.92258 },
	{ x: -154.660004, y: 315.302002, z: 6.2954 },
	{ x: -152.268005, y: 314.559998, z: 2.67315 },
	{ x: -149.804001, y: 313.93399, z: -0.944174 },
	{ x: -147.266998, y: 313.424988, z: -4.55657 },
	{ x: -144.656998, y: 313.032013, z: -8.16404 },
	{ x: -141.975006, y: 312.756012, z: -11.7666 },
	{ x: -139.220001, y: 312.596008, z: -15.3642 },
	{ x: -136.393005, y: 312.553009, z: -18.9569 },
	{ x: -133.492004, y: 312.626007, z: -22.544701 },
	{ x: -130.520004, y: 312.81601, z: -26.127501 },
	{ x: -127.473999, y: 313.122009, z: -29.7054 },
	{ x: -124.356003, y: 313.545013, z: -33.2784 },
	{ x: -121.212997, y: 314.085999, z: -36.807999 },
	{ x: -118.094002, y: 314.747009, z: -40.255798 },
	{ x: -114.998001, y: 315.528992, z: -43.621899 },
	{ x: -111.926003, y: 316.429993, z: -46.906101 },
	{ x: -108.876999, y: 317.450989, z: -50.108501 },
	{ x: -105.851997, y: 318.59201, z: -53.229099 },
	{ x: -102.849998, y: 319.852997, z: -56.268002 },
	{ x: -99.8713, y: 321.234009, z: -59.224998 },
	{ x: -96.916298, y: 322.734985, z: -62.100201 },
	{ x: -93.984703, y: 324.355988, z: -64.8936 },
	{ x: -91.076599, y: 326.096985, z: -67.605301 },
	{ x: -88.191902, y: 327.958008, z: -70.2351 },
	{ x: -85.330803, y: 329.938995, z: -72.783096 },
	{ x: -82.492996, y: 332.040009, z: -75.249298 },
	{ x: -79.678703, y: 334.26001, z: -77.633797 },
	{ x: -76.887901, y: 336.601013, z: -79.936401 },
	{ x: -74.120499, y: 339.062012, z: -82.157204 },
	{ x: -71.376602, y: 341.643005, z: -84.296303 },
	{ x: -68.656197, y: 344.343994, z: -86.3535 },
	{ x: -65.959198, y: 347.165009, z: -88.328903 },
	{ x: -63.285599, y: 350.105988, z: -90.222603 },
	{ x: -60.635601, y: 353.165985, z: -92.034401 },
	{ x: -58.0089, y: 356.346985, z: -93.764397 },
	{ x: -55.4058, y: 359.64801, z: -95.412697 },
	{ x: -52.826099, y: 363.069, z: -96.979103 },
	{ x: -50.269798, y: 366.609009, z: -98.463699 },
	{ x: -47.737, y: 370.269989, z: -99.8666 },
	{ x: -45.227699, y: 374.050995, z: -101.188004 },
	{ x: -42.741798, y: 377.951996, z: -102.427002 },
	{ x: -40.2794, y: 381.971985, z: -103.584 },
	{ x: -37.840401, y: 386.113007, z: -104.660004 },
	{ x: -35.4249, y: 390.373993, z: -105.653999 },
	{ x: -33.032902, y: 394.753998, z: -106.566002 },
	{ x: -30.664301, y: 399.255005, z: -107.396004 },
	{ x: -28.319099, y: 403.875, z: -108.143997 },
	{ x: -25.997499, y: 408.615997, z: -108.810997 },
	{ x: -23.646299, y: 413.398987, z: -109.408997 },
	{ x: -21.212601, y: 418.145996, z: -109.952003 },
	{ x: -18.6964, y: 422.856995, z: -110.440002 },
	{ x: -16.097799, y: 427.53299, z: -110.873001 },
	{ x: -13.4166, y: 432.173004, z: -111.250999 },
	{ x: -10.653, y: 436.778015, z: -111.573997 },
	{ x: -7.80685, y: 441.346985, z: -111.842003 },
	{ x: -4.87823, y: 445.880005, z: -112.054001 },
	{ x: -1.86713, y: 450.377991, z: -112.211998 },
	{ x: 1.22647, y: 454.839996, z: -112.314003 },
	{ x: 4.40255, y: 459.265991, z: -112.362 },
	{ x: 7.66112, y: 463.657013, z: -112.353996 },
	{ x: 11.0022, y: 468.011993, z: -112.291 },
	{ x: 14.4257, y: 472.330994, z: -112.172997 },
	{ x: 17.931801, y: 476.61499, z: -112 },
	{ x: 21.5203, y: 480.863007, z: -111.772003 },
	{ x: 25.191299, y: 485.075012, z: -111.488998 },
	{ x: 28.944799, y: 489.252014, z: -111.151001 },
	{ x: 32.7808, y: 493.393005, z: -110.758003 },
	{ x: 36.699299, y: 497.498993, z: -110.308998 },
	{ x: 40.700199, y: 501.567993, z: -109.806 },
	{ x: 44.783699, y: 505.602997, z: -109.247002 },
	{ x: 48.9496, y: 509.601013, z: -108.634003 },
	{ x: 53.198101, y: 513.564026, z: -107.964996 },
	{ x: 57.528999, y: 517.491028, z: -107.240997 },
	{ x: 61.942402, y: 521.382996, z: -106.461998 },
	{ x: 66.438301, y: 525.239014, z: -105.627998 },
	{ x: 71.016701, y: 529.059021, z: -104.738998 },
	{ x: 75.677597, y: 532.843994, z: -103.794998 },
	{ x: 80.420898, y: 536.593018, z: -102.795998 },
	{ x: 85.246803, y: 540.30603, z: -101.741997 },
	{ x: 90.155098, y: 543.984009, z: -100.632004 },
	{ x: 95.146004, y: 547.625977, z: -99.467796 },
	{ x: 100.219002, y: 551.232971, z: -98.248299 },
	{ x: 105.375, y: 554.804016, z: -96.973701 },
	{ x: 110.612999, y: 558.338989, z: -95.643997 },
	{ x: 115.872002, y: 561.802002, z: -94.260696 },
	{ x: 121.087997, y: 565.156982, z: -92.825401 },
	{ x: 126.262001, y: 568.403992, z: -91.338097 },
	{ x: 131.393997, y: 571.54303, z: -89.798698 },
	{ x: 136.483994, y: 574.572998, z: -88.207298 },
	{ x: 141.531998, y: 577.495972, z: -86.563904 },
	{ x: 146.537994, y: 580.309998, z: -84.868401 },
	{ x: 151.501007, y: 583.015991, z: -83.120903 },
	{ x: 156.421997, y: 585.612976, z: -81.321404 },
	{ x: 161.300995, y: 588.103027, z: -79.469803 },
	{ x: 166.138, y: 590.484009, z: -77.5662 },
	{ x: 170.932999, y: 592.757996, z: -75.610603 },
	{ x: 175.686005, y: 594.922974, z: -73.602898 },
	{ x: 180.395996, y: 596.97998, z: -71.543198 },
	{ x: 185.065002, y: 598.927979, z: -69.431503 },
	{ x: 189.690994, y: 600.768982, z: -67.2677 },
	{ x: 194.274994, y: 602.500977, z: -65.051903 },
	{ x: 198.817001, y: 604.125, z: -62.7841 },
	{ x: 203.317001, y: 605.640991, z: -60.464199 },
	{ x: 207.774002, y: 607.049011, z: -58.0923 },
	{ x: 212.190002, y: 608.348022, z: -55.6684 },
	{ x: 216.563004, y: 609.539978, z: -53.192402 },
	{ x: 220.893997, y: 610.622986, z: -50.664398 },
	{ x: 225.182999, y: 611.598022, z: -48.0844 },
	{ x: 229.429993, y: 612.463989, z: -45.452301 },
	{ x: 233.634995, y: 613.223022, z: -42.7682 },
	{ x: 237.796997, y: 613.872986, z: -40.032001 },
	{ x: 241.917999, y: 614.416016, z: -37.2439 },
	{ x: 245.996002, y: 614.849976, z: -34.403702 },
	{ x: 250.031998, y: 615.176025, z: -31.5114 },
	{ x: 254.026001, y: 615.393005, z: -28.567101 },
	{ x: 257.977997, y: 615.502991, z: -25.570801 },
	{ x: 261.886993, y: 615.504028, z: -22.522499 },
	{ x: 265.755005, y: 615.396973, z: -19.4221 },
	{ x: 269.579987, y: 615.182007, z: -16.269699 },
	{ x: 273.363007, y: 614.859009, z: -13.0653 },
	{ x: 277.074005, y: 614.437012, z: -9.85806 },
	{ x: 280.681, y: 613.926025, z: -6.69737 },
	{ x: 284.184998, y: 613.327026, z: -3.58319 },
	{ x: 287.585999, y: 612.638, z: -0.515518 },
	{ x: 290.882996, y: 611.861023, z: 2.50564 },
	{ x: 294.076996, y: 610.994995, z: 5.48029 },
	{ x: 297.167999, y: 610.039001, z: 8.40842 },
	{ x: 300.156006, y: 608.994995, z: 11.29 },
	{ x: 303.040009, y: 607.862, z: 14.1252 },
	{ x: 305.821991, y: 606.640991, z: 16.913799 },
	{ x: 308.498993, y: 605.330017, z: 19.6558 },
	{ x: 311.074005, y: 603.929993, z: 22.3514 },
	{ x: 313.54599, y: 602.442017, z: 25.0005 },
	{ x: 315.914001, y: 600.86499, z: 27.603001 },
	{ x: 318.178986, y: 599.197998, z: 30.1591 },
	{ x: 320.339996, y: 597.442993, z: 32.668598 },
	{ x: 322.398987, y: 595.598999, z: 35.131599 },
	{ x: 324.354004, y: 593.666016, z: 37.548199 },
	{ x: 326.204987, y: 591.643982, z: 39.918201 },
	{ x: 327.95401, y: 589.533997, z: 42.2416 },
	{ x: 329.598999, y: 587.333984, z: 44.5186 },
	{ x: 331.140991, y: 585.046021, z: 46.7491 },
	{ x: 332.579987, y: 582.66803, z: 48.932999 },
	{ x: 333.915985, y: 580.202026, z: 51.070499 },
	{ x: 335.14801, y: 577.646973, z: 53.1614 },
	{ x: 336.277008, y: 575.002991, z: 55.205799 },
	{ x: 337.303009, y: 572.27002, z: 57.203701 },
	{ x: 338.226013, y: 569.447998, z: 59.155102 },
	{ x: 339.045013, y: 566.536987, z: 61.060001 },
	{ x: 339.760986, y: 563.538025, z: 62.9184 },
	{ x: 340.373993, y: 560.448975, z: 64.730202 },
	{ x: 340.882996, y: 557.271973, z: 66.495598 },
	{ x: 341.289001, y: 554.005981, z: 68.214401 },
	{ x: 341.59201, y: 550.650024, z: 69.886703 },
	{ x: 341.791992, y: 547.205994, z: 71.512604 },
	{ x: 341.889008, y: 543.674011, z: 73.091904 },
	{ x: 341.888, y: 540.098022, z: 74.619003 },
	{ x: 341.79599, y: 536.525024, z: 76.088203 },
	{ x: 341.614014, y: 532.955994, z: 77.499496 },
	{ x: 341.341003, y: 529.388977, z: 78.852798 },
	{ x: 340.97699, y: 525.825989, z: 80.1483 },
	{ x: 340.522003, y: 522.265991, z: 81.385902 },
	{ x: 339.976013, y: 518.710022, z: 82.565598 },
	{ x: 339.339996, y: 515.156006, z: 83.687401 },
	{ x: 338.612, y: 511.605988, z: 84.751297 },
	{ x: 337.794006, y: 508.058014, z: 85.757301 },
	{ x: 336.88501, y: 504.514008, z: 86.705399 },
	{ x: 335.88501, y: 500.972992, z: 87.595596 },
	{ x: 334.794006, y: 497.436005, z: 88.427902 },
	{ x: 333.612, y: 493.901001, z: 89.202301 },
	{ x: 332.338989, y: 490.369995, z: 89.9188 },
	{ x: 330.976013, y: 486.84201, z: 90.5774 },
	{ x: 329.520996, y: 483.316986, z: 91.178101 },
	{ x: 327.976013, y: 479.795013, z: 91.720901 },
	{ x: 326.339996, y: 476.276001, z: 92.205704 },
	{ x: 324.613007, y: 472.760986, z: 92.632698 },
	{ x: 322.795013, y: 469.247986, z: 93.001801 },
	{ x: 320.886993, y: 465.739014, z: 93.313004 },
	{ x: 318.886993, y: 462.233002, z: 93.566299 },
	{ x: 316.796997, y: 458.730011, z: 93.761703 },
	{ x: 314.61499, y: 455.230988, z: 93.8992 },
	{ x: 312.342987, y: 451.734009, z: 93.978798 },
	{ x: 309.980011, y: 448.240997, z: 94.000504 },
	{ x: 307.526001, y: 444.751007, z: 93.964302 },
	{ x: 304.981995, y: 441.264008, z: 93.870102 },
	{ x: 302.346008, y: 437.779999, z: 93.718102 },
	{ x: 299.619995, y: 434.299011, z: 93.508202 },
	{ x: 296.802002, y: 430.821991, z: 93.240402 },
	{ x: 293.894012, y: 427.347992, z: 92.914703 },
	{ x: 290.894989, y: 423.877014, z: 92.531097 },
	{ x: 287.804993, y: 420.408997, z: 92.0896 },
	{ x: 284.625, y: 416.944, z: 91.590103 },
	{ x: 281.382996, y: 413.493988, z: 91.030502 },
	{ x: 278.112, y: 410.069, z: 90.408401 },
	{ x: 274.809998, y: 406.670013, z: 89.723701 },
	{ x: 271.477997, y: 403.29599, z: 88.976501 },
	{ x: 268.115997, y: 399.947998, z: 88.166801 },
	{ x: 264.722992, y: 396.625, z: 87.294601 },
	{ x: 261.300995, y: 393.32901, z: 86.359901 },
	{ x: 257.847992, y: 390.057007, z: 85.362602 },
	{ x: 254.365005, y: 386.811005, z: 84.302902 },
	{ x: 250.850998, y: 383.591003, z: 83.180603 },
	{ x: 247.307999, y: 380.397003, z: 81.995796 },
	{ x: 243.733994, y: 377.22699, z: 80.748497 },
	{ x: 240.130005, y: 374.084015, z: 79.438599 },
	{ x: 236.494995, y: 370.966003, z: 78.0662 },
	{ x: 232.830994, y: 367.873993, z: 76.631401 },
	{ x: 229.136002, y: 364.807007, z: 75.134003 },
	{ x: 225.410995, y: 361.765991, z: 73.574097 },
	{ x: 221.656006, y: 358.75, z: 71.951599 },
	{ x: 217.871002, y: 355.76001, z: 70.266701 },
	{ x: 214.054993, y: 352.795013, z: 68.519203 },
	{ x: 210.209, y: 349.856995, z: 66.709198 },
	{ x: 206.332993, y: 346.942993, z: 64.8367 },
	{ x: 202.425995, y: 344.054993, z: 62.901699 },
	{ x: 198.490005, y: 341.192993, z: 60.904099 },
	{ x: 194.522995, y: 338.356995, z: 58.844101 },
	{ x: 190.526001, y: 335.54599, z: 56.7215 },
	{ x: 186.498993, y: 332.76001, z: 54.5364 },
	{ x: 182.440994, y: 330, z: 52.288799 },
	{ x: 178.352997, y: 327.265991, z: 49.9786 },
	{ x: 174.235001, y: 324.557007, z: 47.605999 },
	{ x: 170.087006, y: 321.873993, z: 45.170799 },
	{ x: 165.908997, y: 319.216003, z: 42.6731 },
	{ x: 161.699997, y: 316.584015, z: 40.1129 },
	{ x: 157.460999, y: 313.977997, z: 37.4902 },
	{ x: 153.192001, y: 311.397003, z: 34.804901 },
	{ x: 148.893005, y: 308.841003, z: 32.057201 },
	{ x: 144.576004, y: 306.290009, z: 29.2756 },
	{ x: 140.253998, y: 303.720001, z: 26.489 },
	{ x: 135.925995, y: 301.131012, z: 23.697399 },
	{ x: 131.593994, y: 298.524994, z: 20.900801 },
	{ x: 127.257004, y: 295.899994, z: 18.0991 },
	{ x: 122.915001, y: 293.256989, z: 15.2924 },
	{ x: 118.568001, y: 290.595001, z: 12.4806 },
	{ x: 114.214996, y: 287.915009, z: 9.66385 },
	{ x: 109.858002, y: 285.21701, z: 6.84202 },
	{ x: 105.496002, y: 282.501007, z: 4.01517 },
	{ x: 101.127998, y: 279.765991, z: 1.18328 },
	{ x: 96.756104, y: 277.013, z: -1.65365 },
	{ x: 92.378601, y: 274.240997, z: -4.49561 },
	{ x: 87.996101, y: 271.451996, z: -7.34261 },
	{ x: 83.608597, y: 268.644012, z: -10.1946 },
	{ x: 79.216103, y: 265.817993, z: -13.0517 },
	{ x: 74.818497, y: 262.972992, z: -15.9138 },
	{ x: 70.415802, y: 260.109985, z: -18.780899 },
	{ x: 66.008202, y: 257.229004, z: -21.653099 },
	{ x: 61.595501, y: 254.328995, z: -24.5303 },
	{ x: 57.1777, y: 251.412003, z: -27.4126 },
	{ x: 52.755001, y: 248.475006, z: -30.299801 },
	{ x: 48.327099, y: 245.520996, z: -33.1922 },
	{ x: 43.894299, y: 242.548004, z: -36.0895 },
	{ x: 39.456402, y: 239.557007, z: -38.991901 },
	{ x: 35.0135, y: 236.548004, z: -41.8993 },
	{ x: 30.5655, y: 233.520004, z: -44.811798 },
	{ x: 26.112499, y: 230.473999, z: -47.729198 },
	{ x: 21.654499, y: 227.410004, z: -50.651798 },
	{ x: 17.1915, y: 224.328003, z: -53.5793 },
	{ x: 12.7233, y: 221.227005, z: -56.511902 },
	{ x: 8.25021, y: 218.108002, z: -59.449501 },
	{ x: 3.77203, y: 214.970001, z: -62.3922 },
	{ x: -0.711178, y: 211.813995, z: -65.339897 },
	{ x: -5.19943, y: 208.639999, z: -68.292603 },
	{ x: -9.69271, y: 205.447998, z: -71.250397 },
	{ x: -14.1473, y: 202.229996, z: -74.163498 },
	{ x: -18.519501, y: 198.979004, z: -76.982002 },
	{ x: -22.8092, y: 195.694, z: -79.7061 },
	{ x: -27.0165, y: 192.376999, z: -82.335701 },
	{ x: -31.1413, y: 189.026001, z: -84.870697 },
	{ x: -35.1838, y: 185.643005, z: -87.311302 },
	{ x: -39.143799, y: 182.225998, z: -89.657501 },
	{ x: -43.0214, y: 178.776001, z: -91.909103 },
	{ x: -46.816502, y: 175.294006, z: -94.0662 },
	{ x: -50.529202, y: 171.778, z: -96.128899 },
	{ x: -54.1595, y: 168.229004, z: -98.097099 },
	{ x: -57.707401, y: 164.645996, z: -99.970703 },
	{ x: -61.172798, y: 161.031006, z: -101.75 },
	{ x: -64.555801, y: 157.382996, z: -103.434998 },
	{ x: -67.8563, y: 153.701004, z: -105.025002 },
	{ x: -71.074501, y: 149.987, z: -106.521004 },
	{ x: -74.210197, y: 146.238998, z: -107.921997 },
	{ x: -77.263397, y: 142.459, z: -109.228996 },
	{ x: -80.234299, y: 138.645004, z: -110.441002 },
	{ x: -83.122704, y: 134.798004, z: -111.558998 },
	{ x: -85.928703, y: 130.917999, z: -112.582001 },
	{ x: -88.652199, y: 127.004997, z: -113.511002 },
	{ x: -91.293297, y: 123.058998, z: -114.345001 },
	{ x: -93.851997, y: 119.079002, z: -115.084999 },
	{ x: -96.3283, y: 115.067001, z: -115.730003 },
	{ x: -98.722099, y: 111.021004, z: -116.280998 },
	{ x: -101.032997, y: 106.943001, z: -116.737 },
	{ x: -103.262001, y: 102.831001, z: -117.098999 },
	{ x: -105.408997, y: 98.686302, z: -117.366997 },
	{ x: -107.473, y: 94.508499, z: -117.540001 },
	{ x: -109.455002, y: 90.297501, z: -117.617996 },
	{ x: -111.353996, y: 86.053398, z: -117.601997 },
	{ x: -113.170998, y: 81.776299, z: -117.490997 },
	{ x: -114.904999, y: 77.466003, z: -117.286003 },
	{ x: -116.556999, y: 73.122597, z: -116.987 },
	{ x: -118.126999, y: 68.746201, z: -116.593002 },
	{ x: -119.583, y: 64.377296, z: -116.111 },
	{ x: -120.896004, y: 60.056702, z: -115.549004 },
	{ x: -122.065002, y: 55.784302, z: -114.906998 },
	{ x: -123.089996, y: 51.560101, z: -114.183998 },
	{ x: -123.972, y: 47.384201, z: -113.380997 },
	{ x: -124.709999, y: 43.2565, z: -112.498001 },
	{ x: -125.304001, y: 39.177101, z: -111.533997 },
	{ x: -125.753998, y: 35.145901, z: -110.489998 },
	{ x: -126.060997, y: 31.163, z: -109.364998 },
	{ x: -126.223999, y: 27.2283, z: -108.160004 },
	{ x: -126.244003, y: 23.341801, z: -106.874001 },
	{ x: -126.119003, y: 19.503599, z: -105.508003 },
	{ x: -125.850998, y: 15.7137, z: -104.061996 },
	{ x: -125.439003, y: 11.9719, z: -102.535004 },
	{ x: -124.884003, y: 8.27845, z: -100.928001 },
	{ x: -124.184998, y: 4.63321, z: -99.2407 },
	{ x: -123.342003, y: 1.03621, z: -97.472801 },
	{ x: -122.355003, y: -2.51254, z: -95.624397 },
	{ x: -121.224998, y: -6.01306, z: -93.695702 },
	{ x: -119.950996, y: -9.46532, z: -91.686501 },
	{ x: -118.532997, y: -12.8694, z: -89.597 },
	{ x: -116.971001, y: -16.2251, z: -87.427002 },
	{ x: -115.265999, y: -19.5327, z: -85.176598 },
	{ x: -113.417, y: -22.792, z: -82.845901 },
	{ x: -111.425003, y: -26.003, z: -80.4347 },
	{ x: -109.288002, y: -29.1658, z: -77.9431 },
	{ x: -107.008003, y: -32.280399, z: -75.371101 },
	{ x: -104.584999, y: -35.346699, z: -72.718697 },
	{ x: -102.016998, y: -38.364799, z: -69.985901 },
	{ x: -99.306, y: -41.334702, z: -67.172699 },
	{ x: -96.451103, y: -44.256302, z: -64.279099 },
	{ x: -93.452499, y: -47.129601, z: -61.305099 },
	{ x: -90.310204, y: -49.9547, z: -58.250702 },
	{ x: -87.0242, y: -52.731602, z: -55.115898 },
	{ x: -83.594498, y: -55.460201, z: -51.9006 },
	{ x: -80.021103, y: -58.140598, z: -48.605 },
	{ x: -76.375397, y: -60.721802, z: -45.2761 },
	{ x: -72.728897, y: -63.152599, z: -41.9613 },
	{ x: -69.081596, y: -65.433197, z: -38.660301 },
	{ x: -65.433502, y: -67.563599, z: -35.373299 },
	{ x: -61.7845, y: -69.543701, z: -32.1003 },
	{ x: -58.1348, y: -71.373497, z: -28.841299 },
	{ x: -54.4842, y: -73.053001, z: -25.596201 },
	{ x: -50.832901, y: -74.582298, z: -22.365 },
	{ x: -47.180698, y: -75.961403, z: -19.1478 },
	{ x: -43.527802, y: -77.190102, z: -15.9446 },
	{ x: -39.874001, y: -78.2686, z: -12.7553 },
	{ x: -36.219398, y: -79.196899, z: -9.58003 },
	{ x: -32.563999, y: -79.974899, z: -6.41868 },
	{ x: -28.907801, y: -80.6026, z: -3.27128 },
	{ x: -25.250799, y: -81.080002, z: -0.137851 },
	{ x: -21.592899, y: -81.407204, z: 2.98162 },
	{ x: -17.934299, y: -81.584099, z: 6.08714 },
	{ x: -14.2749, y: -81.610802, z: 9.1787 },
	{ x: -10.6146, y: -81.487198, z: 12.2563 },
	{ x: -6.95356, y: -81.213303, z: 15.3199 },
	{ x: -3.29168, y: -80.7892, z: 18.3696 },
	{ x: 0.370995, y: -80.214798, z: 21.4053 },
	{ x: 4.03448, y: -79.490196, z: 24.427099 },
	{ x: 7.69878, y: -78.615196, z: 27.4349 },
	{ x: 11.3639, y: -77.590103, z: 30.428801 },
	{ x: 15.0298, y: -76.414597, z: 33.4086 },
	{ x: 18.696501, y: -75.088898, z: 36.374599 },
	{ x: 22.3641, y: -73.6129, z: 39.3265 },
	{ x: 26.0324, y: -71.986702, z: 42.264599 },
	{ x: 29.701599, y: -70.210197, z: 45.188599 },
	{ x: 33.371498, y: -68.283501, z: 48.098701 },
	{ x: 37.042301, y: -66.206398, z: 50.994801 },
	{ x: 40.713902, y: -63.979198, z: 53.876999 },
	{ x: 44.386299, y: -61.601601, z: 56.745201 },
	{ x: 48.059502, y: -59.073799, z: 59.599499 },
	{ x: 51.733501, y: -56.395699, z: 62.4398 },
	{ x: 55.354698, y: -53.603901, z: 65.238998 },
	{ x: 58.869499, y: -50.734901, z: 67.969902 },
	{ x: 62.277901, y: -47.788601, z: 70.632599 },
	{ x: 65.580002, y: -44.765099, z: 73.226997 },
	{ x: 68.775597, y: -41.664299, z: 75.753098 },
	{ x: 71.864799, y: -38.486401, z: 78.210899 },
	{ x: 74.847702, y: -35.231098, z: 80.600502 },
	{ x: 77.724098, y: -31.898701, z: 82.921799 },
	{ x: 80.494202, y: -28.489, z: 85.174896 },
	{ x: 83.157799, y: -25.0021, z: 87.359703 },
	{ x: 85.715103, y: -21.438, z: 89.476196 },
	{ x: 88.166, y: -17.7967, z: 91.524498 },
	{ x: 90.510399, y: -14.0781, z: 93.504402 },
	{ x: 92.748497, y: -10.2823, z: 95.416199 },
	{ x: 94.880203, y: -6.40921, z: 97.259598 },
	{ x: 96.905502, y: -2.45892, z: 99.034798 },
	{ x: 98.824402, y: 1.56859, z: 100.741997 },
	{ x: 100.637001, y: 5.67333, z: 102.379997 },
	{ x: 102.343002, y: 9.8553, z: 103.950996 },
	{ x: 103.943001, y: 14.1145, z: 105.453003 },
	{ x: 105.435997, y: 18.450899, z: 106.887001 },
	{ x: 106.822998, y: 22.864599, z: 108.251999 },
	{ x: 108.102997, y: 27.355499, z: 109.550003 },
	{ x: 109.278, y: 31.923599, z: 110.778999 },
	{ x: 110.345001, y: 36.569, z: 111.939003 },
	{ x: 111.306999, y: 41.291599, z: 113.031998 },
	{ x: 112.162003, y: 46.0914, z: 114.056 },
	{ x: 112.910004, y: 50.968399, z: 115.012001 },
	{ x: 113.552002, y: 55.922699, z: 115.900002 },
	{ x: 114.087997, y: 60.954201, z: 116.719002 },
	{ x: 114.516998, y: 66.063004, z: 117.471001 },
	{ x: 114.839996, y: 71.248901, z: 118.153 },
	{ x: 115.056999, y: 76.512199, z: 118.767998 },
	{ x: 115.167, y: 81.8526, z: 119.315002 },
	{ x: 115.170998, y: 87.270302, z: 119.792999 },
	{ x: 115.068001, y: 92.765099, z: 120.202003 },
	{ x: 114.878998, y: 98.288399, z: 120.551003 },
	{ x: 114.621002, y: 103.791, z: 120.844002 },
	{ x: 114.294998, y: 109.274002, z: 121.082001 },
	{ x: 113.902, y: 114.736, z: 121.264999 },
	{ x: 113.441002, y: 120.177002, z: 121.392998 },
	{ x: 112.911003, y: 125.598, z: 121.464996 },
	{ x: 112.314003, y: 130.998993, z: 121.483002 },
	{ x: 111.649002, y: 136.378998, z: 121.445999 },
	{ x: 110.916, y: 141.738998, z: 121.352997 },
	{ x: 110.114998, y: 147.078003, z: 121.206001 },
	{ x: 109.247002, y: 152.397003, z: 121.002998 },
	{ x: 108.309998, y: 157.695999, z: 120.746002 },
	{ x: 107.305, y: 162.973007, z: 120.432999 },
	{ x: 106.233002, y: 168.231003, z: 120.065002 },
	{ x: 105.093002, y: 173.468002, z: 119.641998 },
	{ x: 103.884003, y: 178.684998, z: 119.164001 },
	{ x: 102.608002, y: 183.880997, z: 118.630997 },
	{ x: 101.264, y: 189.057007, z: 118.042999 },
	{ x: 99.852303, y: 194.212006, z: 117.400002 },
	{ x: 98.372498, y: 199.347, z: 116.702003 },
	{ x: 96.824799, y: 204.462006, z: 115.948997 },
	{ x: 95.209198, y: 209.556, z: 115.139999 },
	{ x: 93.525597, y: 214.628998, z: 114.277 },
	{ x: 91.7742, y: 219.682007, z: 113.358002 },
	{ x: 89.954903, y: 224.714996, z: 112.385002 },
	{ x: 88.067703, y: 229.727005, z: 111.356003 },
	{ x: 86.112602, y: 234.718994, z: 110.272003 },
	{ x: 84.0896, y: 239.690002, z: 109.133003 },
	{ x: 81.998703, y: 244.641006, z: 107.940002 },
	{ x: 79.839798, y: 249.572006, z: 106.691002 },
	{ x: 77.613098, y: 254.481995, z: 105.387001 },
	{ x: 75.318497, y: 259.372009, z: 104.027 },
	{ x: 72.956001, y: 264.240997, z: 102.612999 },
	{ x: 70.525597, y: 269.088989, z: 101.143997 },
	{ x: 68.027298, y: 273.917999, z: 99.619698 },
	{ x: 65.461098, y: 278.726013, z: 98.040298 },
	{ x: 62.8148, y: 283.506989, z: 96.397499 },
	{ x: 60.075901, y: 288.256012, z: 94.682999 },
	{ x: 57.244701, y: 292.971985, z: 92.896797 },
	{ x: 54.320999, y: 297.654999, z: 91.039001 },
	{ x: 51.304798, y: 302.306, z: 89.109398 },
	{ x: 48.196201, y: 306.924011, z: 87.1082 },
	{ x: 44.995201, y: 311.509003, z: 85.035301 },
	{ x: 41.701698, y: 316.062012, z: 82.890701 },
	{ x: 38.3158, y: 320.582001, z: 80.6744 },
	{ x: 34.837399, y: 325.069, z: 78.386398 },
	{ x: 31.2666, y: 329.523987, z: 76.026703 },
	{ x: 27.603399, y: 333.946014, z: 73.595398 },
	{ x: 23.847601, y: 338.335999, z: 71.0923 },
	{ x: 19.9995, y: 342.692993, z: 68.517601 },
	{ x: 16.058901, y: 347.016998, z: 65.871201 },
	{ x: 12.0259, y: 351.308014, z: 63.153099 },
	{ x: 7.90039, y: 355.566986, z: 60.3633 },
	{ x: 3.68247, y: 359.792999, z: 57.501801 },
];

class Spline {
	constructor() {
		this.curve = new THREE.CatmullRomCurve3(line.map(({ x, y, z }) => new THREE.Vector3(x, y, z)));

		this.geometry = new THREE.Geometry();
		this.geometry.vertices = this.curve.getPoints(150);
		this.material = new THREE.LineBasicMaterial({ color: 0x000000 });
		this.line = new THREE.Line(this.geometry, this.material);
	}
}

export default Spline;



// WEBPACK FOOTER //
// ./src/threejs/sculpture/Spline.js